import styled from '@emotion/styled'

const Text = styled.p`
  font-size: 14px;
  margin: 10px 20px;
`

export default Text
